document.addEventListener("DOMContentLoaded", function () {
  const galleries = document.querySelectorAll(".gallery-section");

  if (!galleries.length) return;

  galleries.forEach(function (section) {
    section.removeAttribute("aria-hidden");

    const grid = section.querySelector(".js-gallery-grid");
    const actions = section.querySelector(".js-gallery-actions");
    const button = section.querySelector(".js-gallery-load-more");

    if (!grid || !actions || !button) {
      initLightbox();
      return;
    }

    const galleryId = grid.dataset.galleryId;
    const dataNode = document.getElementById(galleryId + "-data");

    if (!dataNode) {
      initLightbox();
      return;
    }

    let payload = null;
    let isLoading = false;
    let observer = null;

    try {
      payload = JSON.parse(dataNode.textContent);
    } catch (e) {
      payload = null;
    }

    if (!payload || !Array.isArray(payload.images)) {
      initLightbox();
      return;
    }

    function initLightbox() {
      if (typeof GLightbox === "undefined") return;

      if (!window.__summitGalleryLightbox) {
        window.__summitGalleryLightbox = GLightbox({
          selector: ".glightbox",
          touchNavigation: true,
          loop: false,
        });
      } else if (typeof window.__summitGalleryLightbox.reload === "function") {
        window.__summitGalleryLightbox.reload();
      }
    }

    function getOffset() {
      return parseInt(grid.dataset.offset || "0", 10);
    }

    function getPerPage() {
      return parseInt(grid.dataset.perPage || "12", 10);
    }

    function getTotal() {
      return parseInt(grid.dataset.total || "0", 10);
    }

    function setOffset(value) {
      grid.dataset.offset = String(value);
    }

    function hideControlsIfDone() {
      if (getOffset() >= getTotal()) {
        if (observer) {
          observer.disconnect();
        }
        actions.remove();
      }
    }

    function appendItems(items) {
      if (!items.length) return;

      const fragment = document.createDocumentFragment();

      items.forEach(function (item) {
        const link = document.createElement("a");
        link.href = item.full;
        link.className = "gallery-grid__item glightbox";

        const img = document.createElement("img");
        img.src = item.thumb;
        img.alt = item.alt || "";
        img.className = "gallery-grid__image";
        img.loading = "lazy";

        link.appendChild(img);
        fragment.appendChild(link);
      });

      grid.appendChild(fragment);
      initLightbox();
    }

    function loadMore() {
      if (isLoading) return;
      if (getOffset() >= getTotal()) {
        hideControlsIfDone();
        return;
      }

      isLoading = true;
      section.classList.add("is-loading");
      button.disabled = true;

      const offset = getOffset();
      const perPage = getPerPage();
      const nextItems = payload.images.slice(offset, offset + perPage);

      appendItems(nextItems);
      setOffset(offset + nextItems.length);

      isLoading = false;
      section.classList.remove("is-loading");
      button.disabled = false;

      hideControlsIfDone();
    }

    button.addEventListener("click", function () {
      loadMore();
    });

    if ("IntersectionObserver" in window) {
      observer = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting) {
              loadMore();
            }
          });
        },
        {
          root: null,
          rootMargin: "250px 0px",
          threshold: 0,
        },
      );

      observer.observe(actions);
    }

    hideControlsIfDone();
    initLightbox();
  });
});
